import { AxiosError } from "axios";

export interface ErrorState {
  isError: boolean;
  field?: string;
  message: string;
}

export interface ErrorCatchAxios extends AxiosError {
  data: any;
}
export interface BusinessDaysArray {
  nameDays: string;
  date: string;
  dateFull: string;
}

export interface FormFieldsDataProps {
  date: string;
  time: string;
  description?: string;
}
export interface HolidayProps {
  title: string;
  date: string;
  identifier: string;
}
export interface ButtonGridItemProps {
  isActive?: () => boolean;
}

export const arrayTimes: Array<string> = [
  "08:00",
  "09:00",
  "10:00",
  "11:00",
  "12:00",
  "13:00",
  "14:00",
  "15:00",
  "16:00"
];

export enum EnumErrorCodeRequest {
  GENERIC_ERROR = "generic_error",
  INVALID_TICKET = "already_scheduling"
}
